import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { format } from 'date-fns'; // Add this import for date formatting
import {
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

const validationSchema = Yup.object({
  methodName: Yup.string().required('Method name is required'),
  description: Yup.string().required('Description is required'),
});

const initialValues = {
  methodName: '',
  description: '',
  // createdBy/updatedBy/dates are server-side
};

const NSSFContributionMethodsForm = ({ open, onClose, onSubmit, record, mode = 'create' }) => {
  const isEdit = mode === 'edit';
  const values = isEdit && record 
    ? { 
        ...initialValues, 
        ...record,
        // Exclude server-side fields from form values
        createdBy: undefined,
        createdDate: undefined,
        updatedBy: undefined,
        updatedDate: undefined,
      } 
    : initialValues;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? 'Edit Method' : 'Add New Method'}</DialogTitle>
      <Formik
        initialValues={values}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize // For edit mode
      >
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <DialogContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                <Field
                  as={TextField}
                  name="methodName"
                  label="Method Name"
                  fullWidth
                  error={touched.methodName && !!errors.methodName}
                  helperText={touched.methodName && errors.methodName}
                />
                <Field
                  as={TextField}
                  name="description"
                  label="Description"
                  multiline
                  rows={4}
                  fullWidth
                  error={touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                />
                {isEdit && record && (
                  <Typography variant="body2" color="textSecondary">
                    Created: {format(new Date(record.createdDate), 'MM/dd/yyyy HH:mm')} by {record.createdBy}
                  </Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {isEdit ? 'Update' : 'Create'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default NSSFContributionMethodsForm;